import React, { useState } from 'react';
import './AircraftApplicationForm.css';
import { supabase } from '../supabase';

const AircraftApplicationForm = () => {
  const [applicationType, setApplicationType] = useState('');
  const [formData, setFormData] = useState({
    // Applicant Details
    fullName: '',
    businessAddress: '',
    contactPerson: '',
    phone: '',
    email: '',
    natureOfBusiness: '',
    companyRegNo: '',
    countryOfRegistration: '',
    aviationAuthority: '',
    aocNumber: '',
    aocExpiry: '',
    // Aircraft Request
    aircraftCategory: '',
    preferredManufacturer: '',
    model: '',
    yearOfManufacture: '',
    registrationNumber: '',
    serialNumber: '',
    engineType: '',
    intendedOperation: '',
    primaryArea: '',
    commencementDate: '',
    // Lease Section
    leaseStructure: '',
    leasePeriod: '',
    leasePayment: '',
    leasePaymentFrequency: '',
    securityDeposit: '',
    flightHours: '',
    estimatedHours: '',
    maintenanceResponsibility: '',
    insuranceResponsibility: '',
    returnDate: '',
    // Purchase Section
    purchasePrice: '',
    initialDeposit: '',
    financedBalance: '',
    repaymentPeriod: '',
    repaymentAmount: '',
    paymentFrequency: '',
    sourceOfRepayment: '',
    estimatedRevenue: '',
    registeredOwner: '',
    // Pilot / Operational
    operatedByApplicant: '',
    proposedOperator: '',
    crewArrangement: '',
    crewLicensing: '',
    maintenanceOrganization: '',
    aircraftBase: '',
    // Insurance & Compliance
    insuranceProvider: '',
    insuranceType: '',
    insuranceCertificate: '',
    airworthinessDocs: '',
    regulatoryApprovals: '',
    otherCertifications: '',
    // Guarantor
    guarantorName: '',
    guarantorRelationship: '',
    guarantorPhone: '',
    guarantorEmail: '',
    guarantorAddress: '',
    guarantorOccupation: '',
    guarantorRegNo: '',
    // Declarations
    applicantRepName: '',
    applicantPosition: '',
    applicantSignature: '',
    applicantDate: '',
    guarantorSignedName: '',
    guarantorSignature: '',
    guarantorDate: '',
    agreeTerms: false
  });

  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState({ title: '', message: '', type: '' });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleApplicationTypeChange = (type) => {
    setApplicationType(type);
  };

  const validateForm = () => {
    if (!applicationType) {
      setPopupMessage({
        title: '⚠️ Application Type Required',
        message: 'Please select either AIRCRAFT LEASE or AIRCRAFT HIRE PURCHASE before submitting.',
        type: 'error'
      });
      setShowPopup(true);
      return false;
    }

    const required = [
      'fullName', 'businessAddress', 'contactPerson', 'phone', 'email',
      'natureOfBusiness', 'countryOfRegistration', 'aviationAuthority',
      'aircraftCategory', 'preferredManufacturer', 'model', 'yearOfManufacture',
      'engineType', 'intendedOperation', 'primaryArea', 'commencementDate',
      'operatedByApplicant', 'proposedOperator', 'crewArrangement',
      'maintenanceOrganization', 'aircraftBase',
      'insuranceProvider', 'insuranceType', 'insuranceCertificate',
      'airworthinessDocs', 'regulatoryApprovals',
      'guarantorName', 'guarantorRelationship', 'guarantorPhone',
      'guarantorEmail', 'guarantorAddress', 'guarantorOccupation',
      'applicantRepName', 'applicantPosition', 'applicantDate',
      'guarantorSignedName', 'guarantorDate'
    ];

    for (const field of required) {
      if (!formData[field]) return false;
    }

    if (applicationType === 'lease') {
      if (!formData.leaseStructure || !formData.leasePeriod || !formData.leasePayment ||
          !formData.leasePaymentFrequency || !formData.maintenanceResponsibility ||
          !formData.insuranceResponsibility || !formData.returnDate) return false;
    } else if (applicationType === 'purchase') {
      if (!formData.purchasePrice || !formData.initialDeposit || !formData.financedBalance ||
          !formData.repaymentPeriod || !formData.repaymentAmount || !formData.paymentFrequency ||
          !formData.sourceOfRepayment || !formData.registeredOwner) return false;
    }

    return true;
  };

  const closePopup = () => {
    setShowPopup(false);
    if (formStatus === 'success') {
      setFormData({
        fullName: '',
        businessAddress: '',
        contactPerson: '',
        phone: '',
        email: '',
        natureOfBusiness: '',
        companyRegNo: '',
        countryOfRegistration: '',
        aviationAuthority: '',
        aocNumber: '',
        aocExpiry: '',
        aircraftCategory: '',
        preferredManufacturer: '',
        model: '',
        yearOfManufacture: '',
        registrationNumber: '',
        serialNumber: '',
        engineType: '',
        intendedOperation: '',
        primaryArea: '',
        commencementDate: '',
        leaseStructure: '',
        leasePeriod: '',
        leasePayment: '',
        leasePaymentFrequency: '',
        securityDeposit: '',
        flightHours: '',
        estimatedHours: '',
        maintenanceResponsibility: '',
        insuranceResponsibility: '',
        returnDate: '',
        purchasePrice: '',
        initialDeposit: '',
        financedBalance: '',
        repaymentPeriod: '',
        repaymentAmount: '',
        paymentFrequency: '',
        sourceOfRepayment: '',
        estimatedRevenue: '',
        registeredOwner: '',
        operatedByApplicant: '',
        proposedOperator: '',
        crewArrangement: '',
        crewLicensing: '',
        maintenanceOrganization: '',
        aircraftBase: '',
        insuranceProvider: '',
        insuranceType: '',
        insuranceCertificate: '',
        airworthinessDocs: '',
        regulatoryApprovals: '',
        otherCertifications: '',
        guarantorName: '',
        guarantorRelationship: '',
        guarantorPhone: '',
        guarantorEmail: '',
        guarantorAddress: '',
        guarantorOccupation: '',
        guarantorRegNo: '',
        applicantRepName: '',
        applicantPosition: '',
        applicantSignature: '',
        applicantDate: '',
        guarantorSignedName: '',
        guarantorSignature: '',
        guarantorDate: '',
        agreeTerms: false
      });
      setApplicationType('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);

    if (!validateForm()) {
      setPopupMessage({
        title: '⚠️ Incomplete Form',
        message: 'Please fill in all required fields before submitting.',
        type: 'error'
      });
      setShowPopup(true);
      setLoading(false);
      return;
    }

    try {
      const { error } = await supabase
        .from('aircraft_applications')
        .insert([{
          application_type: applicationType,
          full_name: formData.fullName,
          business_address: formData.businessAddress,
          contact_person: formData.contactPerson,
          phone: formData.phone,
          email: formData.email,
          nature_of_business: formData.natureOfBusiness,
          company_reg_no: formData.companyRegNo,
          country_of_registration: formData.countryOfRegistration,
          aviation_authority: formData.aviationAuthority,
          aoc_number: formData.aocNumber,
          aoc_expiry: formData.aocExpiry,
          aircraft_category: formData.aircraftCategory,
          preferred_manufacturer: formData.preferredManufacturer,
          model: formData.model,
          year_of_manufacture: formData.yearOfManufacture,
          registration_number: formData.registrationNumber,
          serial_number: formData.serialNumber,
          engine_type: formData.engineType,
          intended_operation: formData.intendedOperation,
          primary_area: formData.primaryArea,
          commencement_date: formData.commencementDate,
          lease_structure: formData.leaseStructure,
          lease_period: formData.leasePeriod,
          lease_payment: formData.leasePayment,
          lease_payment_frequency: formData.leasePaymentFrequency,
          security_deposit: formData.securityDeposit,
          flight_hours: formData.flightHours,
          estimated_hours: formData.estimatedHours,
          maintenance_responsibility: formData.maintenanceResponsibility,
          insurance_responsibility: formData.insuranceResponsibility,
          return_date: formData.returnDate,
          purchase_price: formData.purchasePrice,
          initial_deposit: formData.initialDeposit,
          financed_balance: formData.financedBalance,
          repayment_period: formData.repaymentPeriod,
          repayment_amount: formData.repaymentAmount,
          payment_frequency: formData.paymentFrequency,
          source_of_repayment: formData.sourceOfRepayment,
          estimated_revenue: formData.estimatedRevenue,
          registered_owner: formData.registeredOwner,
          operated_by_applicant: formData.operatedByApplicant,
          proposed_operator: formData.proposedOperator,
          crew_arrangement: formData.crewArrangement,
          crew_licensing: formData.crewLicensing,
          maintenance_organization: formData.maintenanceOrganization,
          aircraft_base: formData.aircraftBase,
          insurance_provider: formData.insuranceProvider,
          insurance_type: formData.insuranceType,
          insurance_certificate: formData.insuranceCertificate,
          airworthiness_docs: formData.airworthinessDocs,
          regulatory_approvals: formData.regulatoryApprovals,
          other_certifications: formData.otherCertifications,
          guarantor_name: formData.guarantorName,
          guarantor_relationship: formData.guarantorRelationship,
          guarantor_phone: formData.guarantorPhone,
          guarantor_email: formData.guarantorEmail,
          guarantor_address: formData.guarantorAddress,
          guarantor_occupation: formData.guarantorOccupation,
          guarantor_reg_no: formData.guarantorRegNo,
          applicant_rep_name: formData.applicantRepName,
          applicant_position: formData.applicantPosition,
          applicant_signature: formData.applicantSignature,
          applicant_date: formData.applicantDate,
          guarantor_signed_name: formData.guarantorSignedName,
          guarantor_signature: formData.guarantorSignature,
          guarantor_date: formData.guarantorDate,
          status: 'pending'
        }]);

      if (error) throw error;

      setFormStatus('success');
      setPopupMessage({
        title: '✅ Application Submitted!',
        message: 'Your aircraft application has been successfully received. Our team will contact you within 48 hours.',
        type: 'success'
      });
      setShowPopup(true);
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus('error');
      setPopupMessage({
        title: '❌ Submission Failed',
        message: 'There was a problem submitting your application. Please try again or contact us directly.',
        type: 'error'
      });
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="aircraft-form-page">
      {/* POPUP MODAL */}
      {showPopup && (
        <div className="popup-overlay" onClick={closePopup}>
          <div className={`popup-content ${popupMessage.type}`} onClick={(e) => e.stopPropagation()}>
            <div className="popup-icon">
              {popupMessage.type === 'success' ? '✅' : '❌'}
            </div>
            <h2>{popupMessage.title}</h2>
            <p>{popupMessage.message}</p>
            <button className="popup-btn" onClick={closePopup}>
              {popupMessage.type === 'success' ? 'Continue' : 'Try Again'}
            </button>
          </div>
        </div>
      )}

      <section className="form-hero">
        <h1>ABVIG Aircraft Lease & Purchase Application Form</h1>
        <p>For Aircraft Lease, Hire Purchase and Purchase Financing Transactions</p>
      </section>

      <section className="form-section">
        <div className="container">
          <div className="form-wrapper">
            <div className="form-header">
              <h2>Application Type — Select ONE (Required)</h2>
              <div className="application-type-selector">
                <button
                  className={`type-btn ${applicationType === 'lease' ? 'active' : ''}`}
                  onClick={() => handleApplicationTypeChange('lease')}
                >
                  ☐ AIRCRAFT LEASE
                </button>
                <button
                  className={`type-btn ${applicationType === 'purchase' ? 'active' : ''}`}
                  onClick={() => handleApplicationTypeChange('purchase')}
                >
                  ☐ AIRCRAFT HIRE PURCHASE / PURCHASE FINANCING
                </button>
              </div>
              {!applicationType && (
                <p className="type-required">⚠️ Please select an application type to continue</p>
              )}
            </div>

            <form onSubmit={handleSubmit}>
              {/* Application Date & No */}
              <div className="form-row two-col">
                <div className="form-group">
                  <label>Application Date *</label>
                  <input type="date" value={new Date().toISOString().split('T')[0]} disabled />
                </div>
                <div className="form-group">
                  <label>Application No.</label>
                  <input type="text" value={`ABVIG-AIR-${Date.now().toString().slice(-6)}`} disabled />
                </div>
              </div>

              {/* 1. APPLICANT / OPERATOR DETAILS */}
              <div className="form-section-title">
                <h3>1. APPLICANT / OPERATOR DETAILS</h3>
              </div>

              <div className="form-group">
                <label>Full Name / Registered Company Name *</label>
                <input type="text" name="fullName" value={formData.fullName} onChange={handleInputChange} required placeholder="Enter full name or company name" />
              </div>

              <div className="form-group">
                <label>Registered Business Address *</label>
                <input type="text" name="businessAddress" value={formData.businessAddress} onChange={handleInputChange} required placeholder="Enter registered business address" />
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Contact Person *</label>
                  <input type="text" name="contactPerson" value={formData.contactPerson} onChange={handleInputChange} required placeholder="Enter contact person name" />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" value={formData.phone} onChange={handleInputChange} required placeholder="+234 800 000 0000" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" name="email" value={formData.email} onChange={handleInputChange} required placeholder="email@company.com" />
                </div>
                <div className="form-group">
                  <label>Nature of Business / Aviation Activity *</label>
                  <input type="text" name="natureOfBusiness" value={formData.natureOfBusiness} onChange={handleInputChange} required placeholder="e.g., Charter Services, Corporate Aviation" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Company Registration No.</label>
                  <input type="text" name="companyRegNo" value={formData.companyRegNo} onChange={handleInputChange} placeholder="Enter registration number" />
                </div>
                <div className="form-group">
                  <label>Country of Registration *</label>
                  <input type="text" name="countryOfRegistration" value={formData.countryOfRegistration} onChange={handleInputChange} required placeholder="e.g., Nigeria" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Aviation Authority / Regulatory Authority *</label>
                  <input type="text" name="aviationAuthority" value={formData.aviationAuthority} onChange={handleInputChange} required placeholder="e.g., NCAA" />
                </div>
                <div className="form-group">
                  <label>Air Operator Certificate (AOC) No.</label>
                  <input type="text" name="aocNumber" value={formData.aocNumber} onChange={handleInputChange} placeholder="Enter AOC number" />
                </div>
              </div>

              <div className="form-group">
                <label>AOC Expiry Date</label>
                <input type="date" name="aocExpiry" value={formData.aocExpiry} onChange={handleInputChange} />
              </div>

              {/* 2. AIRCRAFT REQUEST */}
              <div className="form-section-title">
                <h3>2. AIRCRAFT REQUEST</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Aircraft Type / Category *</label>
                  <select name="aircraftCategory" value={formData.aircraftCategory} onChange={handleInputChange} required>
                    <option value="">Select aircraft category</option>
                    <option value="Helicopter">Helicopter</option>
                    <option value="Private Jet">Private Jet</option>
                    <option value="Business Jet">Business Jet</option>
                    <option value="Turboprop">Turboprop</option>
                    <option value="Fixed-Wing Aircraft">Fixed-Wing Aircraft</option>
                    <option value="Cargo Aircraft">Cargo Aircraft</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Preferred Manufacturer *</label>
                  <input type="text" name="preferredManufacturer" value={formData.preferredManufacturer} onChange={handleInputChange} required placeholder="e.g., Boeing, Airbus, Cessna" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Model *</label>
                  <input type="text" name="model" value={formData.model} onChange={handleInputChange} required placeholder="e.g., Boeing 737" />
                </div>
                <div className="form-group">
                  <label>Year of Manufacture *</label>
                  <input type="text" name="yearOfManufacture" value={formData.yearOfManufacture} onChange={handleInputChange} required placeholder="e.g., 2020" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Aircraft Registration / Tail Number (if known)</label>
                  <input type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleInputChange} placeholder="e.g., N12345" />
                </div>
                <div className="form-group">
                  <label>Serial Number / MSN (if known)</label>
                  <input type="text" name="serialNumber" value={formData.serialNumber} onChange={handleInputChange} placeholder="Enter serial number" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Engine Type / Number of Engines *</label>
                  <input type="text" name="engineType" value={formData.engineType} onChange={handleInputChange} required placeholder="e.g., Twin Turbofan" />
                </div>
                <div className="form-group">
                  <label>Intended Operation *</label>
                  <select name="intendedOperation" value={formData.intendedOperation} onChange={handleInputChange} required>
                    <option value="">Select intended operation</option>
                    <option value="Private / Corporate">Private / Corporate</option>
                    <option value="Charter">Charter</option>
                    <option value="Passenger Transport">Passenger Transport</option>
                    <option value="Cargo / Freight">Cargo / Freight</option>
                    <option value="Medical / Emergency">Medical / Emergency</option>
                    <option value="Government / Official">Government / Official</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Primary Area / Region of Operation *</label>
                  <input type="text" name="primaryArea" value={formData.primaryArea} onChange={handleInputChange} required placeholder="e.g., West Africa" />
                </div>
                <div className="form-group">
                  <label>Expected Commencement Date *</label>
                  <input type="date" name="commencementDate" value={formData.commencementDate} onChange={handleInputChange} required />
                </div>
              </div>

              {/* 3. AIRCRAFT LEASE */}
              {applicationType === 'lease' && (
                <div className="conditional-section">
                  <div className="form-section-title lease-title">
                    <h3>3. AIRCRAFT LEASE</h3>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Preferred Lease Structure *</label>
                      <select name="leaseStructure" value={formData.leaseStructure} onChange={handleInputChange} required>
                        <option value="">Select lease structure</option>
                        <option value="Dry Lease">Dry Lease</option>
                        <option value="Wet Lease">Wet Lease</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Preferred Lease Period *</label>
                      <input type="text" name="leasePeriod" value={formData.leasePeriod} onChange={handleInputChange} required placeholder="e.g., 12 months" />
                    </div>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Proposed Lease Payment (₦) *</label>
                      <input type="number" name="leasePayment" value={formData.leasePayment} onChange={handleInputChange} required placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Payment Frequency *</label>
                      <select name="leasePaymentFrequency" value={formData.leasePaymentFrequency} onChange={handleInputChange} required>
                        <option value="">Select frequency</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Security Deposit / Advance Payment (₦)</label>
                      <input type="number" name="securityDeposit" value={formData.securityDeposit} onChange={handleInputChange} placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Proposed Flight Hours / Utilization</label>
                      <input type="text" name="flightHours" value={formData.flightHours} onChange={handleInputChange} placeholder="e.g., 50 hours" />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Estimated Hours per Month</label>
                    <input type="text" name="estimatedHours" value={formData.estimatedHours} onChange={handleInputChange} placeholder="e.g., 40 hours" />
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Maintenance Responsibility *</label>
                      <select name="maintenanceResponsibility" value={formData.maintenanceResponsibility} onChange={handleInputChange} required>
                        <option value="">Select responsibility</option>
                        <option value="Applicant / Lessee">Applicant / Lessee</option>
                        <option value="ABVIG / Lessor">ABVIG / Lessor</option>
                        <option value="As specified in Lease Agreement">As specified in Lease Agreement</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Insurance Responsibility *</label>
                      <select name="insuranceResponsibility" value={formData.insuranceResponsibility} onChange={handleInputChange} required>
                        <option value="">Select responsibility</option>
                        <option value="Applicant / Lessee">Applicant / Lessee</option>
                        <option value="ABVIG / Lessor">ABVIG / Lessor</option>
                        <option value="As specified in Lease Agreement">As specified in Lease Agreement</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Proposed Return Date *</label>
                    <input type="date" name="returnDate" value={formData.returnDate} onChange={handleInputChange} required />
                  </div>

                  <div className="legal-notice">
                    <p>⚠️ I understand that the aircraft remains the property of ABVIG throughout the lease period unless otherwise expressly provided in a written agreement executed by ABVIG.</p>
                  </div>
                </div>
              )}

              {/* 4. AIRCRAFT HIRE PURCHASE */}
              {applicationType === 'purchase' && (
                <div className="conditional-section">
                  <div className="form-section-title purchase-title">
                    <h3>4. AIRCRAFT HIRE PURCHASE / PURCHASE FINANCING</h3>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Aircraft Purchase Price (₦) *</label>
                      <input type="number" name="purchasePrice" value={formData.purchasePrice} onChange={handleInputChange} required placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Proposed Initial Deposit (₦) *</label>
                      <input type="number" name="initialDeposit" value={formData.initialDeposit} onChange={handleInputChange} required placeholder="0.00" />
                    </div>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Proposed Financed Balance (₦) *</label>
                      <input type="number" name="financedBalance" value={formData.financedBalance} onChange={handleInputChange} required placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Proposed Repayment Period *</label>
                      <input type="text" name="repaymentPeriod" value={formData.repaymentPeriod} onChange={handleInputChange} required placeholder="e.g., 60 months" />
                    </div>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Proposed Repayment Amount (₦) *</label>
                      <input type="number" name="repaymentAmount" value={formData.repaymentAmount} onChange={handleInputChange} required placeholder="0.00" />
                    </div>
                    <div className="form-group">
                      <label>Payment Frequency *</label>
                      <select name="paymentFrequency" value={formData.paymentFrequency} onChange={handleInputChange} required>
                        <option value="">Select frequency</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row two-col">
                    <div className="form-group">
                      <label>Source of Repayment *</label>
                      <select name="sourceOfRepayment" value={formData.sourceOfRepayment} onChange={handleInputChange} required>
                        <option value="">Select source</option>
                        <option value="Business Revenue">Business Revenue</option>
                        <option value="Charter Revenue">Charter Revenue</option>
                        <option value="Corporate Funds">Corporate Funds</option>
                        <option value="Investment Income">Investment Income</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>Estimated Monthly/Annual Revenue (₦)</label>
                      <input type="number" name="estimatedRevenue" value={formData.estimatedRevenue} onChange={handleInputChange} placeholder="0.00" />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Intended Registered Owner *</label>
                    <input type="text" name="registeredOwner" value={formData.registeredOwner} onChange={handleInputChange} required placeholder="Enter registered owner name" />
                  </div>

                  <div className="legal-notice">
                    <p>⚠️ I understand that completion of this application does not by itself constitute a sale, transfer of title, or transfer of ownership of the aircraft. Ownership and all related rights shall be governed by the formal Aircraft Hire Purchase / Purchase Agreement executed with ABVIG.</p>
                  </div>
                </div>
              )}

              {/* 5. PILOT / OPERATIONAL INFORMATION */}
              <div className="form-section-title">
                <h3>5. PILOT / OPERATIONAL INFORMATION</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Will the aircraft be operated by the applicant? *</label>
                  <select name="operatedByApplicant" value={formData.operatedByApplicant} onChange={handleInputChange} required>
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Proposed Operator / Air Operator *</label>
                  <input type="text" name="proposedOperator" value={formData.proposedOperator} onChange={handleInputChange} required placeholder="Enter operator name" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Pilot / Crew Arrangement *</label>
                  <select name="crewArrangement" value={formData.crewArrangement} onChange={handleInputChange} required>
                    <option value="">Select arrangement</option>
                    <option value="Applicant's Crew">Applicant's Crew</option>
                    <option value="ABVIG-Approved Crew">ABVIG-Approved Crew</option>
                    <option value="Third-Party Operator">Third-Party Operator</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Pilot / Crew Licensing and Qualification</label>
                  <input type="text" name="crewLicensing" value={formData.crewLicensing} onChange={handleInputChange} placeholder="Enter licensing details" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Maintenance Organization / Provider *</label>
                  <input type="text" name="maintenanceOrganization" value={formData.maintenanceOrganization} onChange={handleInputChange} required placeholder="Enter maintenance provider" />
                </div>
                <div className="form-group">
                  <label>Proposed Aircraft Base / Hangar Location *</label>
                  <input type="text" name="aircraftBase" value={formData.aircraftBase} onChange={handleInputChange} required placeholder="e.g., Lagos, Nigeria" />
                </div>
              </div>

              {/* 6. INSURANCE & REGULATORY COMPLIANCE */}
              <div className="form-section-title">
                <h3>6. INSURANCE & REGULATORY COMPLIANCE</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Proposed Insurance Provider *</label>
                  <input type="text" name="insuranceProvider" value={formData.insuranceProvider} onChange={handleInputChange} required placeholder="Enter insurance provider" />
                </div>
                <div className="form-group">
                  <label>Insurance Type / Coverage *</label>
                  <input type="text" name="insuranceType" value={formData.insuranceType} onChange={handleInputChange} required placeholder="e.g., Hull and Liability" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Insurance Certificate Available *</label>
                  <select name="insuranceCertificate" value={formData.insuranceCertificate} onChange={handleInputChange} required>
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="To Be Provided">To Be Provided</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Aircraft Airworthiness Documentation Available *</label>
                  <select name="airworthinessDocs" value={formData.airworthinessDocs} onChange={handleInputChange} required>
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="To Be Provided">To Be Provided</option>
                  </select>
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Required Regulatory Approvals Available *</label>
                  <select name="regulatoryApprovals" value={formData.regulatoryApprovals} onChange={handleInputChange} required>
                    <option value="">Select option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    <option value="To Be Obtained">To Be Obtained</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Other Relevant Aviation Certifications / Documents</label>
                  <input type="text" name="otherCertifications" value={formData.otherCertifications} onChange={handleInputChange} placeholder="Enter any additional certifications" />
                </div>
              </div>

              <div className="legal-notice">
                <p>⚠️ The applicant acknowledges that the aircraft shall only be operated in accordance with applicable aviation laws, regulations, certifications, approvals, operating limitations, and the requirements of the relevant aviation authorities.</p>
              </div>

              {/* 7. GUARANTOR / CORPORATE REFERENCE */}
              <div className="form-section-title">
                <h3>7. GUARANTOR / CORPORATE REFERENCE</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Full Name / Company Name *</label>
                  <input type="text" name="guarantorName" value={formData.guarantorName} onChange={handleInputChange} required placeholder="Enter guarantor name" />
                </div>
                <div className="form-group">
                  <label>Relationship to Applicant *</label>
                  <input type="text" name="guarantorRelationship" value={formData.guarantorRelationship} onChange={handleInputChange} required placeholder="e.g., Corporate Partner" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input type="tel" name="guarantorPhone" value={formData.guarantorPhone} onChange={handleInputChange} required placeholder="+234 800 000 0000" />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input type="email" name="guarantorEmail" value={formData.guarantorEmail} onChange={handleInputChange} required placeholder="email@company.com" />
                </div>
              </div>

              <div className="form-group">
                <label>Address *</label>
                <input type="text" name="guarantorAddress" value={formData.guarantorAddress} onChange={handleInputChange} required placeholder="Enter address" />
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Occupation / Nature of Business *</label>
                  <input type="text" name="guarantorOccupation" value={formData.guarantorOccupation} onChange={handleInputChange} required placeholder="Enter occupation" />
                </div>
                <div className="form-group">
                  <label>Registration / Identification No.</label>
                  <input type="text" name="guarantorRegNo" value={formData.guarantorRegNo} onChange={handleInputChange} placeholder="Enter registration number" />
                </div>
              </div>

              {/* 8. APPLICANT UNDERTAKING & DECLARATION */}
              <div className="form-section-title">
                <h3>8. APPLICANT UNDERTAKING & DECLARATION</h3>
              </div>

              <div className="declaration-text">
                <p>I/We declare that all information provided in this application is true, accurate and complete.</p>
                <p>I/We understand that ABVIG may verify the information, corporate records, financial information, aviation credentials, operational information, regulatory approvals and documents provided in connection with this application.</p>
                <p>I/We agree that any aircraft made available by ABVIG shall be used responsibly and solely for lawful and approved aviation purposes.</p>
                <p>I/We shall not sell, sublease, assign, transfer, pledge, mortgage, encumber, modify, relocate or otherwise dispose of the aircraft or any interest in it without ABVIG's prior written consent and, where applicable, the required regulatory approvals.</p>
                <p>I/We acknowledge responsibility for complying with all applicable aviation laws, safety requirements, operating limitations, maintenance requirements, insurance requirements and regulatory obligations applicable to the approved arrangement.</p>
                <p>I/We understand that any payment, deposit, application or preliminary approval does not by itself constitute an aircraft sale, lease, transfer of title or transfer of ownership.</p>
                <p>The transaction shall only become effective upon ABVIG's approval and the execution of the appropriate formal agreement and satisfaction of all applicable conditions.</p>
                <p>I/We agree to comply with the applicable Aircraft Lease Agreement or Aircraft Hire Purchase / Purchase Agreement, including provisions relating to payment default, aircraft condition, maintenance, insurance, loss or damage, unauthorized use, regulatory compliance, recovery and termination.</p>
                <p>I/We authorize ABVIG to conduct reasonable due diligence and verification necessary to assess this application.</p>
                <p>I/We confirm that I/We have read and understood this declaration.</p>
              </div>

              <div className="form-row three-col">
                <div className="form-group">
                  <label>Applicant / Authorized Representative Name *</label>
                  <input type="text" name="applicantRepName" value={formData.applicantRepName} onChange={handleInputChange} required placeholder="Full name" />
                </div>
                <div className="form-group">
                  <label>Position *</label>
                  <input type="text" name="applicantPosition" value={formData.applicantPosition} onChange={handleInputChange} required placeholder="Job title" />
                </div>
                <div className="form-group">
                  <label>Date *</label>
                  <input type="date" name="applicantDate" value={formData.applicantDate} onChange={handleInputChange} required />
                </div>
              </div>

              <div className="form-group">
                <label>Signature</label>
                <input type="text" name="applicantSignature" value={formData.applicantSignature} onChange={handleInputChange} placeholder="Digital signature" />
              </div>

              {/* 9. GUARANTOR / REFERENCE DECLARATION */}
              <div className="form-section-title">
                <h3>9. GUARANTOR / REFERENCE DECLARATION</h3>
              </div>

              <div className="declaration-text">
                <p>I/We confirm that the information provided in this section is accurate and that I/We have agreed to act as the applicant's guarantor/reference for the purpose of this application.</p>
                <p>I/We authorize ABVIG to verify the information provided.</p>
                <p>Where a separate guarantee or undertaking is required and executed, I/We agree to be bound by its terms.</p>
              </div>

              <div className="form-row three-col">
                <div className="form-group">
                  <label>Guarantor / Reference Name *</label>
                  <input type="text" name="guarantorSignedName" value={formData.guarantorSignedName} onChange={handleInputChange} required placeholder="Full name" />
                </div>
                <div className="form-group">
                  <label>Signature</label>
                  <input type="text" name="guarantorSignature" value={formData.guarantorSignature} onChange={handleInputChange} placeholder="Digital signature" />
                </div>
                <div className="form-group">
                  <label>Date *</label>
                  <input type="date" name="guarantorDate" value={formData.guarantorDate} onChange={handleInputChange} required />
                </div>
              </div>

              {/* Terms */}
              <div className="form-group checkbox">
                <label className="checkbox-label">
                  <input type="checkbox" name="agreeTerms" checked={formData.agreeTerms} onChange={handleInputChange} required />
                  I confirm that I have read and understood all terms and conditions. *
                </label>
              </div>

              <button type="submit" className="btn-gold submit-btn" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AircraftApplicationForm;